import React, { useState, useEffect, useContext } from "react";
import { Redirect, Link } from "react-router-dom";
import { Icon, Table, notification, Modal, Select } from "antd";
import { Dropdown, Menu } from "antd";
import axios from "axios";
import ModalLoading from "../../../shared/components/Modals/ModalLoading";
import ModalViewer from "../../../shared/components/Modals/ModalViewer";
import ModalAta from "./Drawer/Ata";
import ModalAtaSat from "./Drawer/AtaSAT";
import ModalEmissao from "./Drawer/EmissaoAtaClasse";
import DrawerBuscaAtiva from "./Drawer/BuscaAtiva";

import Acessos from "../../../Geral/Acessos/Acessos";

import { GlobalContext } from "../../../app/providers/GlobalState";

import ModalGerarDocumento from "../../../shared/components/Modals/GerarDocumento";

import { Teacher, Eye, More } from "iconsax-react";
import { FaCog } from "react-icons/fa";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const Relatorios = ({ match }) => {
    const [isSat, setIsSat] = useState(false);
    const [estruturaId, setEstruturaId] = useState(undefined);
    const [alunos, setAlunos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [redirectLink, setRedirectLink] = useState("");
    const [isEnsinoInfantil, setIsEnsinoInfantil] = useState(0);
    const [loadingText, setLoadingText] = useState("");
    const [visibleLoading, setVisibleLoading] = useState(false);
    const [docs, setDocs] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [visibleExportar, setVisibleExportar] = useState(false);
    const [btnDescarregar, setBtnDescarregar] = useState(false);
    const [textoExportar, setTextoExportar] = useState("");
    const [ficheiroNome, setFicheiroNome] = useState("");
    const [ficheiroExportar, setFicheiroExportar] = useState("");
    const [ataVisible, setAtaVisible] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [ataClasseVisible, setAtaClasseVisible] = useState(false);
    const [ataIndividualAgrupEmMassaVisible, setAtaIndividualAgrupEmMassaVisible] = useState(false);
    const [fichaDescritivaEmMassaVisible, setFichaDescritivaEmMassaVisible] = useState(false);
    const [boletimEscolarEmMassaVisible, setBoletimEscolarEmMassaVisible] = useState(false);

    const [fichaExcel, setFichaExcel] = useState(false);
    const [ataAgrupVisible, setAtaAgrupVisible] = useState(false);
    const [individualInfo, setIndividualInfo] = useState({
        visible: false,
        code: ""
    });
    const [individualInfoAgrup, setIndividualInfoAgrup] = useState({
        visible: false,
        code: ""
    });

    const [boletimEscolarInfo, setBoletimEscolarInfo] = useState({
        visible: false,
        code: ""
    });

    const [descritivaInfo, setDescritivaInfo] = useState({
        visible: false,
        code: ""
    });

    const [drawerBuscaAtivaVisible, setDrawerBuscaAtivaVisible] = useState({
        visible: false,
        code: ""
    });

    const [existeFicha, setExisteFicha] = useState(false);
    const [existeAtaClasse, setExisteAtaClasse] = useState(false);

    const context = useContext(GlobalContext);

    const toggleModal = () => {
        setIsModalVisible(!isModalVisible);
    };

    const listar = estruturaId => {
        setLoading(true);
        axios({
            method: "get",
            url: "/api/aproveitamento/listar-alunos",
            params: {
                turmaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                //let alunos = [];

                response.data.map(item => {
                    alunos.push({
                        key: item.id,
                        aluno: `${item.codigo} - ${item.nome}`,
                        opcoes: (
                            <div className="documentos-opcoes" style={{ display: "flex", gap: 10 }}>
                                <Link
                                    to="#"
                                    title="Visualizar"
                                    className="botao-icon-detalhe"
                                    onClick={() =>
                                        setIndividualInfoAgrup({
                                            visible: true,
                                            code: item.code
                                        })
                                    }
                                >
                                    <Icon type="switcher" />
                                </Link>
                                <Link
                                    to="#"
                                    title="Visualizar"
                                    className={`botao-icon-botao-avaliacoes-visualizar ${!estruturaId ? "botao-disabled" : ""}`}
                                    disabled={!estruturaId}
                                    onClick={() =>
                                        setIndividualInfo({
                                            visible: true,
                                            code: item.code
                                        })
                                    }
                                >
                                    <Eye size="24" color="#FFFFFF" />
                                    Visualizar
                                </Link>
                            </div>
                        )
                    });
                });

                setLoading(false);
                setAlunos(response.data);
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    setRedirectLink("/login");
                    setRedirect(true);
                }

                setLoading(false);
            });
    };

    const validarSat = () => {
        axios({
            method: "get",
            url: "/api/aproveitamento/listar-estruturas-avaliacao-turma",
            params: {
                turmaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                setIsSat(response.data);
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    setRedirectLink("/login");
                    setRedirect(true);
                }
            });
    };

    const validarExistenciaFichaDescritiva = () => {
        axios({
            method: "get",
            url: "/api/aproveitamento/validar-existencia-ficha-descritiva",
            params: {
                turmaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                setExisteFicha(response.data);
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    setRedirectLink("/login");
                    setRedirect(true);
                }
            });
    };

    const validarExistenciaAtaClasse = () => {
        axios({
            method: "get",
            url: "/api/aproveitamento/validar-existencia-ata-classe",
            params: {
                turmaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                setExisteAtaClasse(response.data);
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    setRedirectLink("/login");
                    setRedirect(true);
                }
            });
    };

    const validarFichaEnsinoInfantil = () => {
        axios({
            method: "get",
            url: "/api/aproveitamento/validar-ficha-ensino-infantil",
            params: {
                turmaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                setIsEnsinoInfantil(response.data);
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    setRedirectLink("/login");
                    setRedirect(true);
                }
            });
    };

    const carregarFichaIndividualAgrupamento = (code, dataEmissao) => {
        setLoadingText("A carregar documento...");
        setVisibleLoading(true);

        axios({
            method: "get",
            url: "/api/pdf/ficha-anual-fundamental-agrupamento",
            params: {
                estruturaId: estruturaId,
                cursoId: localStorage.getItem("codigo_curso"),
                code,
                dataEmissao: dataEmissao.format("YYYY-MM-DD")
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setVisibleLoading(false);
                setDocs([{ uri: url, fileName }]);
                setModalVisible(true);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar documento!");
                setVisibleLoading(false);
            });
    };

    const carregarBoletimEscolar = (code, dataEmissao) => {
        setLoadingText("A carregar documento...");
        setVisibleLoading(true);

        axios({
            method: "get",
            url: "/api/pdf/boletim-escolar",
            params: {
                estruturaId: estruturaId,
                cursoId: localStorage.getItem("codigo_curso"),
                code,
                dataEmissao: dataEmissao.format("YYYY-MM-DD")
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setVisibleLoading(false);
                setDocs([{ uri: url, fileName }]);
                setModalVisible(true);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar documento!");
                setVisibleLoading(false);
            });
    };

    const carregarFichaAtaClasse = (periodoId, dataEmissao, horaEmissao) => {
        setLoadingText("A carregar documento...");
        setVisibleLoading(true);

        axios({
            method: "get",
            url: "/api/pdf/ata-classes",
            params: {
                cursoId: localStorage.getItem("codigo_curso"),
                periodoId,
                dataEmissao: dataEmissao.format("YYYY-MM-DD"),
                horaEmissao: horaEmissao.format("HH:mm")
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setVisibleLoading(false);
                setDocs([{ uri: url, fileName }]);
                setModalVisible(true);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar documento!");
                setVisibleLoading(false);
            });
    };

    const carregarFichaIndividualAgrupamentoEmMassa = dataEmissao => {
        setVisibleExportar(true);
        setBtnDescarregar(true);

        axios({
            method: "get",
            url: "/api/pdf/ficha-anual-fundamental-agrupamento-em-massa",
            params: {
                cursoId: localStorage.getItem("codigo_curso"),
                dataEmissao: dataEmissao.format("YYYY-MM-DD")
            }
        })
            .then(response => {
                const processoId = response.data;
                setTextoExportar("A gerar ficheiro...");
                verificarEstadoDocumentoEmMassa(processoId);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível exportar documento!");

                setVisibleExportar(false);
            });
    };

    const carregarBoletimEscolarAgrupamentoEmMassa = dataEmissao => {
        setVisibleExportar(true);
        setBtnDescarregar(true);

        axios({
            method: "get",
            url: "/api/pdf/boletim-escolar-agrupamento-em-massa",
            params: {
                cursoId: localStorage.getItem("codigo_curso"),
                dataEmissao: dataEmissao.format("YYYY-MM-DD")
            }
        })
            .then(response => {
                const processoId = response.data;
                setTextoExportar("A gerar ficheiro...");
                verificarEstadoDocumentoEmMassa(processoId);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível exportar documento!");

                setVisibleExportar(false);
            });
    };

    const verificarEstadoDocumentoEmMassa = processId => {
        const interval = setInterval(async () => {
            axios({
                method: "get",
                url: "/api/pdf/document-status",
                params: {
                    processId
                }
            })
                .then(response => {
                    const { mensagem, sucesso, concluido, fileUrl, fileName } = response.data;
                    setTextoExportar(mensagem);

                    if (!sucesso) {
                        clearInterval(interval);
                        setBtnDescarregar(false);
                        setVisibleExportar(false);
                        openNotificationWithIcon("error", "Erro", "Não foi possível exportar documento!");
                    }

                    if (concluido) {
                        clearInterval(interval);
                        setBtnDescarregar(false);
                        setFicheiroNome(fileName);
                        setFicheiroExportar(fileUrl);
                    }
                })
                .catch(() => {
                    clearInterval(interval);
                    setVisibleExportar(false);
                    openNotificationWithIcon("error", "Erro", "Não foi possível exportar documento!");
                });
        }, 2000);
    };

    const carregarFichaDescritivaEmMassa = dataEmissao => {
        setVisibleExportar(true);
        setBtnDescarregar(true);
        axios({
            method: "get",
            url: "/api/pdf/ficha-descritiva-em-massa",
            params: {
                cursoId: localStorage.getItem("codigo_curso"),
                dataEmissao: dataEmissao.format("YYYY-MM-DD")
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setBtnDescarregar(false);
                setTextoExportar("");
                setFicheiroExportar(url);
                setFicheiroNome(fileName);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível exportar documento!");

                setVisibleExportar(false);
            });
    };

    const carregarFichaDescritiva = (code, dataEmissao) => {
        setLoadingText("A carregar documento...");
        setVisibleLoading(true);

        axios({
            method: "get",
            url: "/api/pdf/ficha-descritiva",
            params: {
                code,
                cursoId: localStorage.getItem("codigo_curso"),
                dataEmissao: dataEmissao.format("YYYY-MM-DD")
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setVisibleLoading(false);
                setDocs([{ uri: url, fileName }]);
                setModalVisible(true);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível exportar documento!");

                setVisibleExportar(false);
            });
    };

    const ExportarExcel = () => {
        setVisibleExportar(true);
        setBtnDescarregar(true);
        axios({
            method: "get",
            url: "/api/excel/exportar-notas-excel",
            params: {
                turmaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setBtnDescarregar(false);
                setFicheiroExportar(url);
                setFicheiroNome(fileName);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível exportar documento!");

                setVisibleExportar(false);
            });
    };

    const carregarAtaAgrupamentoResultados = (cursoId, dataEmissao) => {
        setLoadingText("A carregar documento...");
        setVisibleLoading(true);
        axios({
            method: "get",
            url: "/api/pdf/ata-notas-agrupamentos",
            params: {
                cursoId: cursoId === 0 ? localStorage.getItem("codigo_curso") : cursoId,
                estruturaId: estruturaId,
                dataEmissao: dataEmissao.format("YYYY-MM-DD")
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setVisibleLoading(false);
                setDocs([{ uri: url, fileName }]);
                setModalVisible(true);
                setAtaVisible(false);
            })
            .catch(error => {
                /*openNotificationWithIcon("error", "Erro", "Não foi possível carregar documento!");*/
                openNotificationWithIcon("error", "Erro", error.response.data);
                setVisibleLoading(false);
            });
    };

    const montarBotaoVoltar = () => {
        if (localStorage.getItem("opcao_voltar") != null) {
            const opcaoInfo = JSON.parse(localStorage.getItem("opcao_voltar"));
            return (
                <Link
                    to={opcaoInfo.link_voltar_curso ? opcaoInfo.link_voltar_curso : opcaoInfo.link_voltar}
                    className="botao-secundario botao-secundario-redondo"
                    onClick={() => opcaoInfo.id_curso && localStorage.setItem("codigo_curso", opcaoInfo.id_curso)}
                    style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                >
                    <Icon type="arrow-left" />
                </Link>
            );
        }
    };

    useEffect(() => {
        listar();
        validarSat();
        validarExistenciaFichaDescritiva();
        validarExistenciaAtaClasse();
        validarFichaEnsinoInfantil();
    }, []);

    const columns = [
        {
            title: "Aluno",
            dataIndex: "aluno"
        },
        {
            title: "",
            dataIndex: "opcoes",
            width: 10
        }
    ];

    if (redirect) return <Redirect to={redirectLink} />;

    const alunosTemp = alunos.map(item => {
        const menuOpcoes = (
            <Menu>
                <Menu.Item key="0" onClick={() => setIndividualInfoAgrup({ visible: true, code: item.code })}>
                    Ficha individual
                </Menu.Item>
                <Menu.Item key="1" onClick={() => setBoletimEscolarInfo({ visible: true, code: item.code })}>
                    Boletim Escolar
                </Menu.Item>

                {context.id_entidade === 33 && (
                    <Menu.Item key="2" onClick={() => setDrawerBuscaAtivaVisible({ visible: true, code: item.code })}>
                        Busca Ativa
                    </Menu.Item>
                )}
            </Menu>
        );

        return {
            key: item.id,
            aluno: `${item.codigo} - ${item.nome}`,
            opcoes: (
                <div className="tabela-documentos">
                    <div className="documentos-opcoes">
                        {isEnsinoInfantil !== 236 && (
                            <>
                                <Link
                                    to="#"
                                    title="Visualizar"
                                    className="botao-avaliacoes-ficha-ind"
                                    onClick={() =>
                                        setIndividualInfoAgrup({
                                            visible: true,
                                            code: item.code
                                        })
                                    }
                                >
                                    <Eye size="24" color="#FFFFFF" />
                                    Ficha individual
                                </Link>

                                <Link
                                    to="#"
                                    title="Visualizar"
                                    className="botao-boletim-escolar"
                                    onClick={() =>
                                        setBoletimEscolarInfo({
                                            visible: true,
                                            code: item.code
                                        })
                                    }
                                >
                                    <Eye size="24" color="#FFFFFF" />
                                    Boletim Escolar
                                </Link>
                                {context.id_entidade === 33 && (
                                    <Link
                                        to="#"
                                        title="Visualizar"
                                        className="botao-avaliacoes-ficha-des"
                                        onClick={() =>
                                            setDrawerBuscaAtivaVisible({
                                                visible: true,
                                                code: item.code
                                            })
                                        }
                                    >
                                        <Eye size="24" color="#FFFFFF" />
                                        Busca Ativa
                                    </Link>
                                )}
                            </>
                        )}
                        {(context.id_entidade === 3 || context.id_entidade === 28 || context.id_entidade === 37) && existeFicha && (
                            <Link
                                to="#"
                                title="Visualizar"
                                className="botao-avaliacoes-ficha-des"
                                onClick={() => {
                                    setDescritivaInfo({
                                        visible: true,
                                        code: item.code
                                    });
                                }}
                            >
                                <Eye size="24" color="#FFFFFF" />
                                Ficha descritiva
                            </Link>
                        )}
                    </div>
                    <div className="documentos-opcoes-mobile">
                        <Dropdown overlay={menuOpcoes} trigger={["click"]}>
                            <FaCog size={24} className={"botao-opcoes"} />
                        </Dropdown>
                    </div>
                </div>
            )
        };
    });

    const titulo =
        (context.id_entidade === 3 || context.id_entidade === 28 || context.id_entidade === 37) && existeFicha
            ? isEnsinoInfantil === 236
                ? "Fichas Descritivas"
                : "Fichas individuais & Fichas Descritivas"
            : "Fichas individuais";

    return (
        <>
            <Acessos funcionalidadeId={15} />
            <div className="container container-body">
                <div className="turma-visao-geral">
                    <div className="curso-resultados">
                        <div className="controlos controlos-fundo mobile">
                            <div className="bloco-esquerda mobile">
                                <span style={{ fontSize: 18, fontWeight: "bold" }}>Ata de resultados finais:</span>
                                <div className="botao-voltar-mobile">{montarBotaoVoltar()}</div>
                            </div>
                            <div className="bloco-direita-relatorios">
                                <Link to="#" className="botao-avaliacoes-excel" title="Excel" onClick={() => setFichaExcel(true)}>
                                    <Eye size="24" color="#FFFFFF" />
                                    Visualização em excel
                                </Link>
                                <Link
                                    to="#"
                                    className="botao-avaliacoes-visualizar"
                                    title="Visualizar"
                                    onClick={() => setAtaAgrupVisible(true)}
                                >
                                    <Eye size="24" color="#FFFFFF" />
                                    Visualizar
                                </Link>
                                <div className="botao-voltar-desktop">{montarBotaoVoltar()}</div>
                            </div>
                        </div>
                    </div>
                    <div className="bloco">
                        <div className="controlos controlos-fundo mobile">
                            <div className="bloco-esquerda">
                                <span style={{ fontSize: 22, fontWeight: "bold" }}>{titulo}</span>
                            </div>
                            <div className="bloco-direita-relatorios" style={{ marginRight: "10px" }}>
                                {isEnsinoInfantil !== 236 && (
                                    <>
                                        {" "}
                                        <Link
                                            to="#"
                                            className="botao-avaliacoes-ficha-ind"
                                            style={{ display: "flex", gap: 10 }}
                                            title="Visualizar"
                                            onClick={() => setAtaIndividualAgrupEmMassaVisible(true)}
                                        >
                                            <Eye size="24" color="#FFFFFF" />
                                            Fichas individuais
                                        </Link>{" "}
                                        <Link
                                            to="#"
                                            className="botao-boletim-escolar"
                                            style={{ display: "flex", gap: 10 }}
                                            title="Visualizar"
                                            onClick={() => setBoletimEscolarEmMassaVisible(true)}
                                        >
                                            <Eye size="24" color="#FFFFFF" />
                                            Boletins Escolares
                                        </Link>
                                    </>
                                )}
                                {isEnsinoInfantil === 290 && existeAtaClasse && (
                                    <Link to="#" title="Visualizar" className="botao-icon-pdf" onClick={() => setAtaClasseVisible(true)}>
                                        <Eye size="24" color="#FFFFFF" />
                                    </Link>
                                )}
                                {(context.id_entidade === 3 || context.id_entidade === 28 || context.id_entidade === 37) && existeFicha && (
                                    <Link
                                        to="#"
                                        className="botao-avaliacoes-ficha-des"
                                        style={{ display: "flex", gap: 10 }}
                                        title="Visualizar"
                                        onClick={() => setFichaDescritivaEmMassaVisible(true)}
                                    >
                                        <Eye size="24" color="#FFFFFF" />
                                        Fichas descritivas
                                    </Link>
                                )}
                            </div>
                        </div>
                        <Table
                            id="disciplinas"
                            loading={{
                                spinning: loading,
                                indicator: (
                                    <div className="loading-data-table">
                                        <div className="loading" />
                                    </div>
                                )
                            }}
                            columns={columns}
                            dataSource={alunosTemp}
                            pagination={false}
                            locale={{ emptyText: "Não existem dados!" }}
                        />
                    </div>
                </div>
            </div>
            <ModalLoading visible={visibleLoading} text={loadingText} />
            <ModalViewer visible={modalVisible} docs={docs} onCancel={() => setModalVisible(false)} />
            <ModalGerarDocumento
                texto={textoExportar}
                visibleExportar={visibleExportar}
                ficheiroNome={ficheiroNome}
                ficheiroExportar={ficheiroExportar}
                btnDescarregar={btnDescarregar}
                onClose={() => setVisibleExportar(false)}
            />

            <ModalAta //GERAR ZIP COM PDFS DA FICHA INDIVIDUAL
                visible={ataIndividualAgrupEmMassaVisible}
                onClose={() => setAtaIndividualAgrupEmMassaVisible(false)}
                onConfirm={dataEmissao => {
                    carregarFichaIndividualAgrupamentoEmMassa(dataEmissao);
                    setAtaIndividualAgrupEmMassaVisible(false);
                }}
            />

            <ModalAta //GERAR ZIP COM PDFS DA FICHA DESCRITIVA
                visible={fichaDescritivaEmMassaVisible}
                onClose={() => setFichaDescritivaEmMassaVisible(false)}
                onConfirm={dataEmissao => {
                    carregarFichaDescritivaEmMassa(dataEmissao);
                    setFichaDescritivaEmMassaVisible(false);
                }}
            />

            <ModalAta //GERAR ZIP COM PDFS DO BOLETIM ESCOLAR
                visible={boletimEscolarEmMassaVisible}
                onClose={() => setBoletimEscolarEmMassaVisible(false)}
                onConfirm={dataEmissao => {
                    carregarBoletimEscolarAgrupamentoEmMassa(dataEmissao);
                    setBoletimEscolarEmMassaVisible(false);
                }}
            />

            {isSat ? (
                <>
                    <ModalAtaSat
                        visible={ataAgrupVisible}
                        onClose={() => setAtaAgrupVisible(false)}
                        onConfirm={(cursoId, dataEmissao) => {
                            carregarAtaAgrupamentoResultados(cursoId, dataEmissao);
                            setAtaAgrupVisible(false);
                        }}
                    />
                </>
            ) : (
                <ModalAta
                    visible={ataAgrupVisible}
                    onClose={() => setAtaAgrupVisible(false)}
                    onConfirm={dataEmissao => {
                        carregarAtaAgrupamentoResultados(0, dataEmissao);
                        setAtaAgrupVisible(false);
                    }}
                />
            )}

            <ModalAta //GERAR EXCEL
                visible={fichaExcel}
                onClose={() => setFichaExcel(false)}
                onConfirm={() => {
                    ExportarExcel();
                    setFichaExcel(false);
                }}
            />

            <ModalAta //GERAR PDF FICHA INDIVIDUAL
                visible={individualInfoAgrup.visible}
                onClose={() => setIndividualInfoAgrup({ ...individualInfoAgrup, visible: false })}
                onConfirm={dataEmissao => {
                    carregarFichaIndividualAgrupamento(individualInfoAgrup.code, dataEmissao);
                    setIndividualInfoAgrup({ ...individualInfoAgrup, visible: false });
                }}
            />

            <ModalAta //GERAR PDF FICHA BOLETIM ESCOLAR
                visible={boletimEscolarInfo.visible}
                onClose={() => setBoletimEscolarInfo({ ...boletimEscolarInfo, visible: false })}
                onConfirm={dataEmissao => {
                    carregarBoletimEscolar(boletimEscolarInfo.code, dataEmissao);
                    setBoletimEscolarInfo({ ...boletimEscolarInfo, visible: false });
                }}
            />

            {isEnsinoInfantil === 290 && existeAtaClasse && (
                <ModalEmissao //GERAR PDF ATA CLASSE
                    visible={ataClasseVisible}
                    onClose={() => setAtaClasseVisible(false)}
                    onConfirm={(periodo, dataEmissao, horaEmissao) => {
                        carregarFichaAtaClasse(periodo, dataEmissao, horaEmissao);
                        setAtaClasseVisible(false);
                    }}
                />
            )}

            <ModalAta //GERAR PDF FICHA DESCRITIVA
                visible={descritivaInfo.visible}
                onClose={() => setDescritivaInfo({ ...descritivaInfo, visible: false })}
                onConfirm={dataEmissao => {
                    carregarFichaDescritiva(descritivaInfo.code, dataEmissao);
                    setDescritivaInfo({ ...descritivaInfo, visible: false });
                }}
            />

            <DrawerBuscaAtiva
                visible={drawerBuscaAtivaVisible.visible}
                code={drawerBuscaAtivaVisible.code}
                onClose={() => setDrawerBuscaAtivaVisible({ ...drawerBuscaAtivaVisible, visible: false })}
                onConfirm={() => setDrawerBuscaAtivaVisible(false)}
            />
        </>
    );
};
export default Relatorios;
